import { API_PATH } from 'constants/app';
import { api } from 'helper/api';
import { LandingBusinessForm } from 'models/landing';

export function sendBusinessData(formValue: LandingBusinessForm): Promise<void> {
  return api.build().withoutAuth()
    .post(`${API_PATH}/business/email`, {
      email: formValue.email,
      name: formValue.name
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/repositories/landing.ts